import type { CalendarioModulo } from "@/modules/calendario/services/calendarioService";

/**
 * Cores por módulo no Calendário (tokens do design system, doc 08).
 * As strings são literais para o Tailwind conseguir gerar as classes.
 */
export const CORES_MODULO: Record<
  CalendarioModulo,
  { barra: string; ponto: string; tag: string; rotulo: string }
> = {
  evento: { barra: "bg-info", ponto: "bg-info", tag: "bg-info/10 text-info", rotulo: "Evento" },
  reserva: {
    barra: "bg-warning",
    ponto: "bg-warning",
    tag: "bg-warning/10 text-warning",
    rotulo: "Reserva",
  },
  biblioteca: {
    barra: "bg-primary",
    ponto: "bg-primary",
    tag: "bg-primary/10 text-primary",
    rotulo: "Biblioteca",
  },
  escala: {
    barra: "bg-success",
    ponto: "bg-success",
    tag: "bg-success/10 text-success",
    rotulo: "Escala",
  },
};
